import React from 'react';
import Projets from '../ComponentProjets/Projets/Projets';
import Navbar from '../Components/Navbar/Navbar';
import BackButtonUrb from '../ComponentProjets/BackButtonUrb/BackButtonUrb';
import Contact from '../Components/Contact/Contact';
import Footer from '../Components/Footer/Footer';
import Footerbas from '../Components/Footerbas/Footerbas'
import QuickActions from '../Components/QuickActions/QuickActions';
import Publicites from '../Components/Publicites/Publicites';

function Projet() {
    return (
      <div>
        <Navbar/>
        <div className="page-avec-pub">
        {/* CONTENU */}
        <div className="page-contenu"> 
        <Projets/>
        <BackButtonUrb/>
        <Contact/>
         </div>
        
          {/* SIDEBAR DROITE */}
         <div className="sidebar-right">
        
          <QuickActions />
            <Publicites />
        
          </div>
      </div>
        <Footer/>
        <Footerbas/>
      </div>
      
    );
  }
  
  export default Projet;
  